export const detectShiftScheduleIntent = (text: string) => {
    const cleaned = text.toLowerCase().trim();

    /** ----------------------------------
     * DELETE: No name
     * ---------------------------------- */
    if (cleaned === "delete shiftschedule" || cleaned === "remove shiftschedule") {
        return { intent: "delete_shift_schedule" };
    }

    /** ----------------------------------
     * DELETE: With name
     * ---------------------------------- */
    const deleteMatch = cleaned.match(/delete (.+) shiftschedule/);
    if (deleteMatch) {
        return { intent: "delete_shift_schedule", name: deleteMatch[1].trim() };
    }

    /** ----------------------------------
     * CREATE: Without name
     * ---------------------------------- */
    if (cleaned.includes("create shiftschedule") || cleaned.includes("add shiftschedule")) {
        return { intent: "create_shift_schedule" };
    }

    /** ----------------------------------
     * CREATE: With name
     * ---------------------------------- */
    const createMatch = cleaned.match(/create shiftschedule named (.+)/);
    if (createMatch) {
        return { intent: "create_shift_schedule", name: createMatch[1].trim() };
    }

    return null;
};
